import { memo } from 'react';
import { IBadge } from '@bridebook/models/source/models/Suppliers/Badges.types';
import gazetteer, { CountryCodes } from '@bridebook/toolbox/src/gazetteer';
import { getBadgeImageVersion } from '@bridebook/toolbox/src/supplier/utils/get-badge-image-version';
import { Box, ImageX } from '@bridebook/ui';
import { IMAGES_BASE_URL } from '@bridebook/toolbox/src/buildImageUrl';
import componentStyles from './badge.style';

interface IProps {
  type: IBadge['type'];
  year: number;
  supplierCountry?: CountryCodes;
}

const Badge = ({ year, type, supplierCountry }: IProps) => {
  if (!type || !supplierCountry) return null;

  const width = 223;
  const height = 170;

  const { prefix } = gazetteer.getMarketByCountry(supplierCountry);
  const imgVersion = getBadgeImageVersion(year);

  const styles = componentStyles();

  return (
    <Box style={styles.wrapper}>
      <ImageX
        loading="lazy"
        w={width}
        h={height}
        src={`${IMAGES_BASE_URL}/badge/${type}-${year}-${prefix}${imgVersion}.png`}
        fit="scale"
        imageStyle={styles.image}
      />
    </Box>
  );
};

export default memo(Badge);
